var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { TabService } from './tab.service';
import { TabGroupDirective } from './tab.directive';
import { ValidationService } from '../../service/validation.service';
var TabGroupComponent = /** @class */ (function (_super) {
    __extends(TabGroupComponent, _super);
    function TabGroupComponent(router, route, logger, action, message, page, service, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.validService = validService;
        _this.currentIndex = 0;
        _this.tabEvent = {};
        return _this;
    }
    TabGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setTabEvent();
        this.currentIndex = this.service.getTab(this.componentName, this.component.components, this.router.url, this.route.snapshot.queryParamMap.get('tab'));
        this.subsc = this.validService.afterValidationObservable.subscribe(function (flg) {
            if (flg && _this.dir) {
                _this.dir.addError(_this.msgSnapshot['TabGroupComponent.error.input']);
            }
        });
    };
    TabGroupComponent.prototype.ngAfterViewInit = function () {
        this.execTabEvent();
    };
    TabGroupComponent.prototype.setUnsubscribe = function () {
        this.refSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    TabGroupComponent.prototype.onModeSubscribe = function (mode) {
        var previousIndex = this.currentIndex;
        if (mode === 'entry' || mode === 'confirm') {
            this.currentIndex = 0;
            this.service.setTab(this.componentName, this.currentIndex);
        }
        if (mode === 'entry' && this.currentIndex !== previousIndex) {
            this.execTabEvent();
        }
    };
    TabGroupComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.execTabEvent(true);
        }
        else if (e === this.componentName + 'TabReset') {
            this.currentIndex = 0;
            this.service.setTab(this.componentName, this.currentIndex);
            this.execTabEvent();
        }
    };
    TabGroupComponent.prototype.onEvent = function (e1, e2, rec) {
        this.currentIndex = rec;
        this.service.setTab(this.componentName, this.currentIndex);
        this.execTabEvent();
    };
    TabGroupComponent.prototype.setChangeCompData = function (component) {
        if (component.components && component.components.length > 0 && component.components.length === this.component.components.length) {
            for (var i = 0; i < component.components.length; i++) {
                this.component.components[i].title = component.components[i].title;
            }
        }
    };
    TabGroupComponent.prototype.setTabEvent = function () {
        this.tabEvent = {};
        for (var i = 0; i < this.component.components.length; i++) {
            var comp = this.component.components[i];
            if (comp && comp.component === 'TabComponent' && comp.params && comp.params.event) {
                this.tabEvent[i] = {
                    event: comp.params.event,
                    once: (typeof comp.params.once !== 'undefined' ? comp.params.once : false),
                    done: false
                };
            }
        }
    };
    TabGroupComponent.prototype.execTabEvent = function (force) {
        if (force === void 0) { force = false; }
        var tabEvent = this.tabEvent[this.currentIndex];
        if (typeof tabEvent !== 'undefined' && (!tabEvent.once || !tabEvent.done || force)) {
            var event_1 = tabEvent.event;
            if (this.action.validEvent(event_1)) {
                this.action.firstAction(event_1);
            }
            tabEvent.done = true;
        }
    };
    TabGroupComponent.prototype.trackByCompTitle = function (index, component) {
        return component.title;
    };
    TabGroupComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
    };
    TabGroupComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'tab',
                    template: "<div *ngIf=\"component.components?.length > 0\" id=\"{{ componentName }}\" [msg]=\"(msg | async)['TabGroupComponent.error.input']\" tabDir>\n  <ul class=\"tabsMenu\">\n    <ng-template ngFor let-comp [ngForOf]=\"component.components\" let-index=\"index\" [ngForTrackBy]=\"trackByCompTitle\">\n      <li *ngIf=\"comp.component === 'TabComponent'\" [class.tabsMenu_current]=\"currentIndex === index\">\n        <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'click', index)\">{{ comp.title }}</a>\n      </li>\n    </ng-template>\n  </ul>\n  <ng-template ngFor let-comp [ngForOf]=\"component.components\" let-index=\"index\">\n    <div *ngIf=\"comp.component === 'TabComponent'\" class=\"tabsContent\" [style.display]=\"currentIndex === index ? 'block': 'none'\">\n      <content *ngFor=\"let subComp of comp.components\" [component]=\"subComp\"></content>\n    </div>\n  </ng-template>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    TabGroupComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: TabService },
        { type: ValidationService }
    ]; };
    TabGroupComponent.propDecorators = {
        dir: [{ type: ViewChild, args: [TabGroupDirective,] }]
    };
    return TabGroupComponent;
}(ContentBaseComponent));
export { TabGroupComponent };
//# sourceMappingURL=tab.component.js.map